import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, ApiClientError } from '../lib/api';
import type { User } from '../lib/types';
import { LoadingScreen } from './Layout';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api<{ data: User }>('/api/me').then((response) => response.data),
  });
}

export function AuthGuard({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isLoading) return <LoadingScreen message="กำลังตรวจสอบการเข้าสู่ระบบ…" />;
  if (me.error instanceof ApiClientError && me.error.status === 401) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (me.isError) return <Navigate to="/login?error=session" replace />;
  return children;
}
